import request from '@/utils/request'

export function getNovice(data) {
    return request({
        url: '/api/vip/taste_vip_tickets',
        method: 'post',
        data
    })
}

export function tasteVipExpiredCoupon(data) {
    return request({
        url: '/api/vip/taste_vip_expired_coupon',
        method: 'post',
        data
    })
}

export function popupLog(data) {
    return request({
        url: 'api/vip/popup_log',
        method: 'post',
        data
    })
}